const crossSVG = `
    <?xml version="1.0" encoding="utf-8"?>
    <!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     width="88.208px" height="88.207px" viewBox="0 0 88.208 88.207" enable-background="new 0 0 88.208 88.207" xml:space="preserve">
    <g id="Layer_1">
    </g>
    <g id="LiveTXT" display="none">
    </g>
    <g id="GRids">
    <g>
    <g>
    <path fill="#FFFFFF" d="M49.274,44.126L87.086,6.315c1.459-1.409,1.5-3.734,0.091-5.193c-1.41-1.46-3.734-1.501-5.194-0.092
    c-0.03,0.029-0.061,0.06-0.091,0.092l-37.811,37.81L6.271,1.12c-1.46-1.408-3.786-1.368-5.195,0.091
    c-1.375,1.424-1.375,3.681,0,5.104l37.811,37.811L1.075,81.938c-1.434,1.435-1.434,3.76,0,5.194c1.436,1.434,3.76,1.434,5.195,0
    L44.081,49.32l37.811,37.812c1.459,1.409,3.784,1.368,5.194-0.091c1.375-1.423,1.375-3.68,0-5.104L49.274,44.126z"/>
    </g>
    </g>
    </g>
    </svg>
`;

export default crossSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/crossSVG.js